// frontend/src/pages/admin/lcl/components/ExportConfirmModal.jsx
import { FiAlertCircle, FiX } from 'react-icons/fi';

export default function ExportConfirmModal({
  open,
  onClose,
  onConfirm,
  title,
  description,
  confirmLabel = 'Exporter',
  confirmColor = 'green', // 'green' | 'orange' | 'blue'
}) {
  if (!open) return null;

  const confirmCls = {
    green:  'bg-green-600 hover:bg-green-700',
    orange: 'bg-orange-600 hover:bg-orange-700',
    blue:   'bg-blue-600 hover:bg-blue-700',
  }[confirmColor] || 'bg-green-600 hover:bg-green-700';

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded shadow-xl border border-gray-200 w-full max-w-md"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-3 py-2 border-b border-gray-100">
          <div className="flex items-center gap-2">
            <FiAlertCircle className="h-4 w-4 text-amber-500" />
            <div className="text-sm font-bold text-gray-900">{title}</div>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <FiX className="h-4 w-4" />
          </button>
        </div>

        <div className="px-3 py-3 text-[11px] text-gray-600 leading-relaxed">
          {description}
        </div>

        <div className="flex justify-end gap-2 px-3 py-2 bg-gray-50 border-t border-gray-100 rounded-b">
          <button
            onClick={onClose}
            className="px-2.5 py-1.5 rounded text-[11px] font-medium text-gray-600 border border-gray-200 hover:bg-white"
          >
            Annuler
          </button>
          <button
            onClick={onConfirm}
            className={`px-2.5 py-1.5 rounded text-[11px] font-semibold text-white ${confirmCls}`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
